'use strict';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

const COOKIE_NAME = "userconsent";
const MUTABLE_CONSENT_NAMES = [
    "targeting",
    "development",
    "embedded_social_media",
];
const CONSENT_NAMES = [
    "targeting",
    "development",
    "embedded_social_media",
    "personalization",
];
const CONSENT_VERSION = 2;
const DEFAULT_DOMAIN = ".yle.fi";
const ALLOWED_DOMAINS = [DEFAULT_DOMAIN, ".yle.dev"];
const ALLOWED_ENVS = ["prod", "test"];

const encodeQueryData = (data) => {
    const ret = [];
    for (const set of Object.entries(data)) {
        const [key, value] = set;
        if (value !== "" && value != null)
            ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    return ret.join("&");
};
const getDomain = (environment) => {
    return environment === "prod" ? "login.api.yle.fi" : "login.api-test.yle.fi";
};
const getAppKey = (environment) => {
    return {
        app_id: "yle-consent-sdk",
        app_key: environment === "prod"
            ? "9diylCAglIhpRSyHeTSCZc74udkYyOep"
            : "IQdPhmQjDuARXwwUm47AaC3QZZpliWC8",
    };
};
const setCookieLocally = (eventData) => {
    const consents = Object.entries(eventData).reduce((acc, [key, value]) => {
        if (CONSENT_NAMES.includes(key) && value === true) {
            acc.push(key);
        }
        return acc;
    }, []);
    const cookieValue = `v${CONSENT_VERSION}|${consents.join("|")}`;
    api.set(COOKIE_NAME, cookieValue, {
        domain: DEFAULT_DOMAIN,
        expires: 7,
        sameSite: "Lax",
        secure: true,
        path: "/",
    });
};
const setCookie = (environment, eventData) => {
    /* We set cookies with a request to a Login API endpoint, which responds with a
       Set-Cookie header(s), that are handled by the browser. The reason for this is
       that for logged-in user's consent is stored in DB. Also, Safari (and some other browsers)
       only allow setting a cookie client side for a maximum of 7 days.
  
       If Login API call fails, we set the cookie locally for 7 days.
     */
    const domain = getDomain(environment);
    const appKey = getAppKey(environment);
    const dataWithCredentials = Object.assign(Object.assign({}, eventData), appKey);
    const params = encodeQueryData(dataWithCredentials);
    return fetch(`https://${domain}/consent/v2/accept?${params}`, {
        method: "POST",
        credentials: "include",
        mode: "cors",
    })
        .then((response) => {
        if (response.status >= 400) {
            throw new Error("Cookie setting Login API call failed.");
        }
    })
        .catch(() => {
        setCookieLocally(eventData);
    });
};
const getLoginAndConsentStatus = (environment) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    const domain = getDomain(environment);
    const appKey = getAppKey(environment);
    const params = encodeQueryData(appKey);
    const response = yield fetch(`https://${domain}/v1/user/login?${params}`, {
        credentials: "include",
        mode: "cors",
    });
    if (response.status >= 500) {
        throw Error(`Login API unavailable. Response status: ${response.status}`);
    }
    const loggedIn = response.status === 200;
    if (loggedIn) {
        // In case user's consent has expired the values are read from the
        // login response body so that the user can just accept again with previous selections.
        const responseJson = yield response.json();
        const consent = {
            development: ((_a = responseJson.consent) === null || _a === void 0 ? void 0 : _a.values.development) || false,
            targeting: ((_b = responseJson.consent) === null || _b === void 0 ? void 0 : _b.values.targeting) || false,
            embedded_social_media: ((_c = responseJson.consent) === null || _c === void 0 ? void 0 : _c.values.embedded_social_media) || false,
            personalization: responseJson.personalization,
            version: ((_d = responseJson.consent) === null || _d === void 0 ? void 0 : _d.version) || 2,
        };
        const shouldConfirmConsent = responseJson.consent === undefined || ((_e = responseJson.consent) === null || _e === void 0 ? void 0 : _e.expired);
        return {
            loggedIn,
            shouldConfirmConsent,
            consent,
        };
    }
    return {
        loggedIn: false,
        shouldConfirmConsent: false,
        consent: {
            version: 2,
            development: false,
            targeting: false,
            embedded_social_media: false,
            personalization: false,
        },
    };
});

const getApexDomain = () => {
    var _a;
    if (!((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) {
        return null;
    }
    const hostname = window.location.hostname;
    const hostParts = hostname.split(".");
    return `.${hostParts.slice(-2).join(".")}`;
};
const createConsentObject = (consentSdk) => {
    return {
        version: consentSdk._version,
        development: consentSdk._development,
        targeting: consentSdk._targeting,
        embedded_social_media: consentSdk._embedded_social_media,
        personalization: consentSdk._personalization,
    };
};
/**
 * @returns {boolean} consentStateUpdated
 */
const updateConsentStateFromCookie = (consentSdk) => {
    const consentCookie = api.get(COOKIE_NAME);
    if (consentCookie) {
        const parts = consentCookie.split("|");
        const consentVersionFromCookie = parseInt(parts[0].slice(1), 10);
        // Override old version consent cookie values and override current consent selections with
        // values from the cookie.
        // If version is newer than the current version, do nothing.
        if (consentVersionFromCookie <= CONSENT_VERSION) {
            const consentTags = parts.slice(1);
            consentSdk._development = consentTags.indexOf("development") !== -1;
            // Targeting should always be true for logged-in user.
            consentSdk._targeting =
                consentSdk._isLoggedIn || consentTags.indexOf("targeting") !== -1;
            consentSdk._embedded_social_media =
                consentTags.indexOf("embedded_social_media") !== -1;
            consentSdk._personalization =
                consentTags.indexOf("personalization") !== -1;
        }
        // If version is older than the current version, user needs to give consent to the new version.
        return consentVersionFromCookie >= CONSENT_VERSION;
    }
    // No consent cookie. -> Remove all consents from state. Returning false means that
    // consentNeedsToBeUpdated stays true and user will be asked to give consent.
    consentSdk._development = false;
    consentSdk._targeting = false;
    consentSdk._embedded_social_media = false;
    consentSdk._personalization = false;
    return false;
};
const resetConsentStateAndCookie = (consentSdk) => {
    consentSdk._development = false;
    consentSdk._targeting = false;
    consentSdk._embedded_social_media = false;
    consentSdk._personalization = false;
    setCookieLocally({
        development: consentSdk._development,
        domain: consentSdk._domain,
        embedded_social_media: consentSdk._embedded_social_media,
        targeting: consentSdk._targeting,
    });
};
/**
 * Consent change callback gets called when consent is accepted and is different from the previous settings.
 * You can add callbacks with {@link yleConsentSdkHeadless.onChange}.
 *
 * @callback consentCallback
 * @param {object} consent - The consent the user has given.
 * @param {number} [consent.version] - The version of the consent dialog.
 * @param {boolean} [consent.embedded_social_media] - Whether social media cookies are allowed.
 * @param {boolean} [consent.development] - Whether development cookies are allowed.
 * @param {boolean} [consent.targeting] - Whether targeting cookies are allowed.
 */
/**
 * Error handler callback gets called when an error occurs in the SDK.
 * You can register an error handler callback with {@link yleConsentSdkHeadless.onError}.
 *
 * @callback errorCallback
 * @param {object} args - An object containing message and error.
 * @param {string} args.message - Short error message.
 * @param {error} [args.error] - The originally raised error.
 */
/**
 * Headless Consent SDK's main entry point.
 * When you install the Headless Consent SDK to your site, this object gets exported as `window.yleConsentSdkHeadless`.
 */
const yleConsentSdkHeadless = {
    /** @private */
    _initiatingApp: "",
    /** @private */
    _initialListeners: [],
    /** @private */
    _listeners: [],
    /** @private */
    _previousConsent: null,
    /** @private */
    _errorHandler: console.error,
    /** @private */
    _consentNeedsToBeUpdated: true,
    /** @private */
    _environment: "prod",
    /** @private */
    _isLoggedIn: false,
    /** @private */
    _version: CONSENT_VERSION,
    /** @private */
    _development: false,
    /** @private */
    _personalization: false,
    /** @private */
    _targeting: false,
    /** @private */
    _embedded_social_media: false,
    /** @private */
    _domain: DEFAULT_DOMAIN,
    /** @private */
    _updateListeners() {
        const newConsent = createConsentObject(this);
        if (this._initialListeners) {
            this._initialListeners.forEach((listener) => listener(newConsent));
            this._initialListeners = null;
            this._previousConsent = newConsent;
        }
        else {
            this._listeners.forEach((listener) => listener(newConsent));
            this._previousConsent = newConsent;
        }
    },
    /**
     * This private method is here to enable testing
     *
     * @private
     */
    _updateConsentStateFromCookie() {
        return updateConsentStateFromCookie(this);
    },
    /** @private */
    _updateLoggedInAndConsentState() {
        return __awaiter(this, void 0, void 0, function* () {
            return getLoginAndConsentStatus(this._environment)
                .then(({ loggedIn, shouldConfirmConsent, consent }) => {
                this._isLoggedIn = loggedIn;
                if (loggedIn && shouldConfirmConsent) {
                    // In case user's consent has expired the values are read from the
                    // login response body so that the user can just accept again with previous selections.
                    this._development = consent.development;
                    this._targeting = consent.targeting;
                    this._embedded_social_media = consent.embedded_social_media;
                    this._personalization = consent.personalization;
                    this._consentNeedsToBeUpdated = true;
                    this._updateListeners();
                }
                else {
                    const consentStateUpdated = this._updateConsentStateFromCookie();
                    if (consentStateUpdated) {
                        this._consentNeedsToBeUpdated = false;
                        this._updateListeners();
                    }
                }
            })
                .catch((e) => {
                this._handleError(e);
                resetConsentStateAndCookie(this);
                this._consentNeedsToBeUpdated = false;
                this._updateListeners();
            });
        });
    },
    /** @private */
    _handleError(error) {
        if (error instanceof Error)
            this._errorHandler({
                message: `yleConsentSdk: Consent acceptance failed: ${error.message}`,
                error,
            });
    },
    /**
     * Set to true once the Consent SDK has been initialized.
     * @member {boolean} */
    initialized: false,
    /**
     * Initialize the Headless Consent SDK.
     * @param {Object} args - The options for the consent dialog. All options are optional.
     * @param {string} [args.environment=prod] - The environment of the dialog. Valid values are "prod" and "test".
     */
    init(args = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { environment = "prod", initiatingApp = "" } = args;
                this._initiatingApp = initiatingApp;
                this._environment = environment;
                if (!ALLOWED_ENVS.includes(this._environment)) {
                    throw new Error(`Environment ${this._environment} is not allowed. Valid values are ${ALLOWED_ENVS.join(", ")}.`);
                }
                this._domain = getApexDomain() || DEFAULT_DOMAIN;
                if (!ALLOWED_DOMAINS.includes(this._domain)) {
                    throw new Error(`Domain ${this._domain} is not allowed`);
                }
                yield this._updateLoggedInAndConsentState();
                this.initialized = true;
                return Promise.resolve();
            }
            catch (error) {
                if (error instanceof Error)
                    this._errorHandler({
                        message: `yleConsentSdk: SDK initialization failed: ${error.message}`,
                        error,
                    });
            }
        });
    },
    /**
     * Add a consent change listener.
     *
     * The callback will be called in two situations:
     *
     * 1. When Consent SDK has gotten the initial consent data from the cookie.
     * 2. When the consent statuses change and are accepted.
     *
     * The first case can be disabled by setting the option triggerWithInitialConsent to false.
     * If you do that, for example to support server-side rendering (SSR), you have to parse the initial consent yourself!
     *
     * @param {consentCallback} callback - The callback that receives the new consent information.
     * @param {Object} [options] - Callback options. (optional)
     * @param {boolean} [options.triggerWithInitialConsent=true] - Whether to trigger the callback with initial consent
     */
    onChange(callback, options = {}) {
        const { triggerWithInitialConsent = true } = options;
        this._listeners.push(callback);
        if (triggerWithInitialConsent && this._initialListeners !== null) {
            this._initialListeners.push(callback);
        }
    },
    /**
     * Stop a consent change listener from receiving consent changes.
     *
     * @param {consentCallback} callback - The change listener callback to be removed from listeners.
     */
    removeOnChangeListener(callback) {
        this._listeners = this._listeners.filter((listener) => listener !== callback);
    },
    /**
     * Set the consent status for a category
     *
     * @param category
     * @param acceptance
     */
    setConsent(category, acceptance) {
        this[`_${category}`] = acceptance;
    },
    /**
     * Get current consent.
     *
     * Consent is read from the cookie, so this function can be called
     * even if {@link yleConsentSdkHeadless.init} has not been called.
     *
     * If user has not yet given any consent, every consent category will be false.
     * If given consent is for earlier version, every consent category will be false.
     *
     * @returns {Object} consent - {version: number, targeting: boolean, ...}
     */
    getConsent() {
        updateConsentStateFromCookie(this);
        return createConsentObject(this);
    },
    /**
     * Accept the current selection and persist the consent cookie.
     *
     * This will persist the current consent selections and send a request to the backend
     * that will respond with a Set-Cookie header.
     *
     * The acceptance will be valid for 90 days in case only part of the consents are given otherwise 180 days.
     * The acceptance expiry can be set explicitly by using the expiresAfter parameter (days) if the above logic of expiry does not work out for you.
     *
     * @param {Object} args - The options for the accept procedure.
     * @param {number} [args.expiresAfter=90 or 180 days] - The amount of time that the acceptance of choices will be valid. (optional)
     *
     * @returns {Promise<void>}
     */
    accept(args) {
        try {
            const { _development: development, _domain: domain, _targeting: targeting, _embedded_social_media: embedded_social_media, _initiatingApp, } = this;
            return setCookie(this._environment, {
                app: _initiatingApp,
                development,
                domain,
                targeting,
                embedded_social_media,
                expiresAfter: args === null || args === void 0 ? void 0 : args.expiresAfter,
            })
                .then(() => this._updateListeners())
                .catch(this._handleError.bind(this));
        }
        catch (error) {
            this._handleError(error);
            return Promise.reject(error);
        }
    },
    /**
     * Accept all consent categories.
     *
     * This will set all consent categories to true and persist the selection.
     *
     * Useful in cases where you have an "accept all" button in the UI.
     */
    acceptAll() {
        MUTABLE_CONSENT_NAMES.forEach((c) => this.setConsent(c, true));
        return this.accept();
    },
    /**
     * Accept only functional cookies.
     *
     * Useful in cases where you have an "accept necessary" button in the UI.
     */
    acceptNecessary() {
        MUTABLE_CONSENT_NAMES.forEach((c) => this.setConsent(c, false));
        return this.accept();
    },
    /**
     * Add an error handler.
     * @param {errorCallback} errorHandler=console.error - The callback that receives the error information.
     */
    onError(errorHandler) {
        if (errorHandler && typeof errorHandler !== "function") {
            console.error("Argument of onError is not a function");
        }
        else {
            this._errorHandler = errorHandler;
        }
    },
};

exports.yleConsentSdkHeadless = yleConsentSdkHeadless;
